/**
 * Local-only bootstrap: impersonate a mock user without a Firebase login.
 *
 * Which user to impersonate is controlled by env vars in
 * .env.development.local:
 *
 *   REACT_APP_DEV_AUTO_LOGIN_BIGFROG=1          → bigFrogAdmin (legacy)
 *   REACT_APP_DEV_MOCK_USER=carlene             → any key in mockUserData.js
 *
 * The REACT_APP_DEV_MOCK_USER var takes precedence if both are set.
 * Must be imported before any module that reads `currentDomain` from
 * utils/index.js (it's computed once at module load).
 */
import { setToken } from "./localStorageCache";
import { LOCALSTORAGE_KEYS } from "../constants/users";
import MOCK_DATA from "../constants/mockUserData";
import { enableDevWarehouseFresh } from "./devWarehouseFresh";

const MOCK_USER_KEY = process.env.REACT_APP_DEV_MOCK_USER;
const BIGFROG_FLAG = process.env.REACT_APP_DEV_AUTO_LOGIN_BIGFROG === "1";

const TARGET = MOCK_USER_KEY
  ? MOCK_DATA[MOCK_USER_KEY]
  : BIGFROG_FLAG
  ? MOCK_DATA.bigFrogAdmin
  : null;

export const isDevBigFrogMockSession = () => {
  if (!TARGET) return false;
  if (typeof window === "undefined") return false;
  return window.location.hostname === "localhost";
};

export const devBigFrogSettingsPath = "/settings/pricing/network-seller-fee";

export function bootstrapDevMockSession() {
  if (!TARGET) return false;
  if (typeof window === "undefined") return false;
  if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
    return false;
  }

  setToken(LOCALSTORAGE_KEYS.mockUser, {
    uid: TARGET.uid,
    email: TARGET.email || null,
    currentDomain: TARGET.domain,
  });

  setToken(LOCALSTORAGE_KEYS.authUser, {
    uid: TARGET.uid,
    email: TARGET.email || null,
  });
  enableDevWarehouseFresh();
  return true;
}

// Keep legacy name for existing imports.
export const bootstrapDevBigFrogSession = bootstrapDevMockSession;

bootstrapDevMockSession();
